export default __webpack_public_path__ + "static/media/Wulftec.3735c31c.png";